import loadable from '@loadable/component';

export const OrgDashboardManageAdminsPageLoadable = loadable(
  () => import('./OrgDashboardManageAdminsPage'),
  {
    resolveComponent: (module) => module.OrgDashboardManageAdminsPage,
  },
);
